export const GET_CLASS = "GET_CLASS";
export const GET_CLASS_SUCCESS = "GET_CLASS_SUCCESS";
export const GET_CLASS_FAILURE = "GET_CLASS_FAILURE";
export const GET_CLASS_RESET = "GET_CLASS_RESET";

export const EDIT_CLASS = "EDIT_CLASS";
export const EDIT_CLASS_RESET = "EDIT_CLASS_RESET";
export const EDIT_CLASS_SUCCESS = "EDIT_CLASS_SUCCESS";
export const EDIT_CLASS_FAILURE = "EDIT_CLASS_FAILURE";
